import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import Zendesk, { ZendeskAPI } from 'react-zendesk';
import i18n from 'i18n-js';

import * as selectors from '../../reducers';
import { ZENDESK_KEY, WIDGET_SETTINGS } from '../../settings';

type ZendeskChatPropsType = {
  userName: string,
  userEmail: string,
  userPhone: string,
}

const ZendeskChat = ({
  userName,
  userEmail,
  userPhone,
}: ZendeskChatPropsType) => (
  <Zendesk
    zendeskKey={ZENDESK_KEY}
    {...WIDGET_SETTINGS}
    onLoaded={() => {
      setTimeout(() => {
        const zendeskIframe = document.getElementsByClassName(
          'zEWidget-webWidget'
        )[0];
        if (zendeskIframe) {
          zendeskIframe.addEventListener('onload', () => {
            const zendeskDocument = zendeskIframe.contentWindow.document;
            // eslint-disable-next-line one-var
            const zendeskCSS = '.iXRjkk, .dNLEaz, .u-userBackgroundColorNoHover, .dNLEaz:not([disabled]):hover, .dNLEaz:not([disabled]):focus, .dNLEaz:not([disabled]), .dNLEaz:not([disabled]):active, .cGaxgS.cGaxgS.cGaxgS, .cGaxgS.cGaxgS.cGaxgS:hover, .innibx:not([disabled]):hover, .kKmMjv:hover { background: #16cde8 !important; } .dNLEaz, .dNLEaz:not([disabled]) {border: 1px solid #16cde8 !important;} .innibx:not([disabled]) {color: #16cde8 !important;border-color: #16cde8 !important;}',
              zendeskBody = zendeskDocument.zendeskBody || zendeskDocument.getElementsByTagName('body')[0],
              zendeskStyle = zendeskDocument.createElement('style');
 
            zendeskBody.appendChild(zendeskStyle);

            zendeskStyle.type = 'text/css';
            if (zendeskStyle.styleSheet) {
              zendeskStyle.styleSheet.cssText = zendeskCSS;
            } else {
              zendeskStyle.appendChild(document.createTextNode(zendeskCSS));
            }

            ZendeskAPI('webWidget', 'prefill', {
              name: {
                value: userName,
                readOnly: true,
              },
              email: {
                value: userEmail,
                readOnly: true,
              },
              phone: {
                value: userPhone,
                readOnly: true,
              },
            });
            ZendeskAPI('webWidget', 'setLocale', i18n.currentLocale());
          });
        }
      }, 3000);
    }}
  />
);

export default connect(
  state => ({
    userName: `${selectors.getUser(state).first_name} ${selectors.getUser(state).last_name}` ,
    userEmail: selectors.getUser(state).email,
    userPhone: selectors.getUser(state).phone,
  }),
)(ZendeskChat);



// WEBPACK FOOTER //
// ./src/scripts/components/ZendeskChat/index.jsx